import apiClient from './_axios';

/**
 * The header bell's inbox. Paths start at `/notifications` — the axios base
 * URL already ends in `/api`.
 */

export interface AppNotification {
   _id: string;
   type: string;
   title: string;
   body: string;
   link?: { path: string; params?: Record<string, string> };
   severity: 'info' | 'success' | 'warning' | 'error';
   category: string;
   read: boolean;
   createdAt: string;
}

export const fetchUnreadCount = async (): Promise<number> => {
   const { data } = await apiClient.get<{ count: number }>('/notifications/unread-count');
   return data.count;
};

export const fetchNotifications = async (): Promise<AppNotification[]> => {
   const { data } = await apiClient.get<{ notifications: AppNotification[] }>(
      '/notifications',
      { params: { limit: 20 } }
   );
   return data.notifications;
};

export const markNotificationRead = async (id: string) => {
   const { data } = await apiClient.post<{ ok: boolean; count: number }>(
      `/notifications/${id}/read`
   );
   return data;
};

export const markAllNotificationsRead = async () => {
   const { data } = await apiClient.post<{ marked: number; count: number }>(
      '/notifications/read-all'
   );
   return data;
};
